module.exports = __webpack_public_path__ + "img/inventory-icon.e980027d.svg";